import React from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useTenant } from "../../context/TenantContext";

const MyShopOverview = () => {
  const { shop, isLoading, isError } = useTenant();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return <Alert severity="error">Unable to load your shop.</Alert>;
  }

  if (!shop) {
    return <Alert severity="warning">No shop is linked to this account yet.</Alert>;
  }

  return (
    <Card>
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="h4">{shop.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            Shop ID: {shop.shop_id}
          </Typography>
          <Typography variant="body1">
            {shop.description || "No description available."}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Owner: {shop.owner?.username || "Unknown"}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MyShopOverview;
